<template>
    <CHeader fixed class="d-lg-none pl-3 shadow">
        <CButton @click="$store.commit('toggleSidebarMobile')">
            <CIcon size="xl" name="cilMenu" class="text-50"></CIcon>
        </CButton>
        <CHeaderBrand>
            <span class="ml-3 mt-1 text-50">
                <h5 class="m-0 p-0"><strong>hvv-sabbenhausen.de</strong></h5>
                <h6 class="mt-0 mb-2 p-0 text-uppercase">Aktuelles aus unserem Verein</h6>
            </span>
        </CHeaderBrand>
    </CHeader>
</template>


<script>
    export default {
        name: 'HvvHeader',
    }
</script>